import React from "react";
import ModalWrapper from '../ModalWrapper';
import VideoModal from './VideoModal';

const VideoModalWrapper = ({id, onClose, title}) => {

  return (<ModalWrapper>
      <VideoModal id={id} onClose={onClose} title={title}/>
    </ModalWrapper>);
}

export default VideoModalWrapper;
